import { Box, Link } from '@hover/blueprint';
import React from 'react';

interface Props {
  children: React.ReactChild;
  link?: string;
}
const LinkWrapper: React.FC<Props> = ({ children, link }) =>
  link ? (
    <Link target="_blank" href={link} isMinimal>
      <Box pointerEvents="none">{children}</Box>
    </Link>
  ) : (
    <>{children}</>
  );
export default LinkWrapper;
